module.exports = {"510402001":"大渡口街道","510402002":"炳草岗街道","510402003":"南山街道","510402004":"向阳村街道","510402005":"弄弄坪街道","510402006":"枣子坪街道","510402007":"长寿路街道","510402008":"密地街道","510402009":"瓜子坪街道","510402100":"银江镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510402.json
// module id = 2101
// module chunks = 0